window.$ = window.jQuery = require('jquery');

import 'jquery';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';

import AOS from 'aos'
import 'aos/dist/aos.css'

import VueTypedJs from 'vue-typed-js'

Vue.use(VueTypedJs);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2, {
    confirmButtonColor: '#77c142',
    allowOutsideClick: false,
    closeOnConfirm: true
});

require("./assets/fonts/Feather/feather.css");
require("./assets/libs/jarallax/dist/jarallax.css");
require("./assets/libs/highlightjs/styles/vs2015.css");
require("./assets/libs/@fancyapps/fancybox/dist/jquery.fancybox.min.css");
require("./assets/css/theme.css");


require("./assets/libs/bootstrap/dist/js/bootstrap.bundle.min.js");
// require("./assets/libs/smooth-scroll/dist/smooth-scroll.min.js");
// require("./assets/libs/jarallax/dist/jarallax.min.js");
// require("./assets/libs/jarallax/dist/jarallax-video.min.js");
// require("./assets/libs/jarallax/dist/jarallax-element.min.js");
// require("./assets/libs/countup.js/dist/countUp.min.js");
// require("./assets/libs/highlightjs/highlight.pack.min.js");
require("./assets/libs/@fancyapps/fancybox/dist/jquery.fancybox.min.js");
// require("https://api.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.js");
// require("./assets/js/theme.min.js");

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    created() {
        const options = {
            duration: 700,
            easing: 'ease-out-quad',
            once: true,
            startEvent: 'load'
        };
        AOS.init(options);
    },
    render: h => h(App)
}).$mount('#app');
